import { devToolsUnlocked } from './dev-tools';

// TEMPORARY dev lever: "All" and every home category page draw their designed empty state, whatever the account holds,
// so the cards (`category-view/CategoryEmptyState.tsx`) can be checked on a real account. Toggled from Dev
// Tools ▸ "Force home empty states". Gated on `devToolsUnlocked()`, so the key does nothing for a real user.
const KEY = 'symphony-dev:force-home-empty-states';

export function isHomeEmptyForced(): boolean {
  if (typeof window === 'undefined' || !devToolsUnlocked()) return false;
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setHomeEmptyForced(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(KEY, '1');
    else window.localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
}
